import { render, staticRenderFns } from "./setup-owners.vue?vue&type=template&id=4ff40a97&"
import script from "./setup-owners.vue?vue&type=script&lang=ts&"
export * from "./setup-owners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports